package com.klantenstop.web.pages.search

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.data.models.domain.Company
import com.klantenstop.web.data.models.domain.CompanyPin
import com.klantenstop.web.data.models.domain.Coordinates
import com.klantenstop.web.data.models.domain.CuratedCity
import com.klantenstop.web.data.models.domain.SearchParams
import com.klantenstop.web.utils.MVI

interface SearchContract : MVI<SearchContract.State, SearchContract.Intent, SearchContract.Effect> {

    data class State(
        val categories: List<Category> = emptyList(),
        val curatedCities: List<CuratedCity> = emptyList(),
        val searchParams: SearchParams? = null,
        val companies: List<Company> = emptyList(),
        val total: Long = 0,
        val page: Int = 1,
        val pageSize: Int = 20,
        val pins: List<CompanyPin> = emptyList(),
        val mapCenter: Coordinates? = null,
        val loading: Boolean = true
    )

    sealed class Intent {
        data object LoadCategories : Intent()
        data object LoadCuratedCities : Intent()
        data class ClearSearch(val searchParams: SearchParams? = null) : Intent()
        data class Search(val searchParams: SearchParams, val page: Int = 1) : Intent()
    }

    sealed class Effect {
        data class PageOutOfRange(val correctedPage: Int) : Effect()
    }
}
